/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
const _ENV_NAME = process.env.REACT_APP_ENV_NAME;
const REPUVE = process.env.REACT_APP_REPUVE;

const ENV_NAME = REPUVE ? 'repuve' : _ENV_NAME;
const NAYARIT = ENV_NAME === 'nayarit';

// logos
export const logoHeader = require(`./${ENV_NAME}/logo-header.png`);
export const logoFinanzas = require(`./${ENV_NAME}/logo-finanzas.png`);

// Banners
export const publicidad = NAYARIT ? require(`./${ENV_NAME}/images/banner.jpg`) : null;
export const publicidadDos = NAYARIT ? require(`./${ENV_NAME}/images/banner2.png`) : null;
export const Licencias = NAYARIT ? require(`./${ENV_NAME}/images/DescuentoPlacas.png`) : null;

// miscelaneous
export const bg = require(`./${_ENV_NAME}/bg.png`);
export const asistencia = require(`./${_ENV_NAME}/asistencia-contribuyente.svg`);
